import { useTranslation } from 'react-i18next'
import './totalPedido.scss'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import CodigoDescuento from './components/CodigoDescuento'
import ProgramaPuntos from './components/ProgramaPuntos'
import { isPeritoMutua } from '../../../../../../../shared/helpers/functionalities'


const TotalPedido = ({ className = '', handleSelectDirEnvio }) => {
  const { t } = useTranslation()
  const checkoutInfo = useSelector(state => {
    return state.checkout.entity
  });

  const isPerito = isPeritoMutua(checkoutInfo.presupuesto);
  const canShowTotals = Boolean(checkoutInfo?.presupuesto?.direccion_envio_id) || isPerito;

  const getSubTotal = () => {
    return parseFloat(checkoutInfo.presupuesto.subtotal).toFixed(2);
  }

  const getDisplayedSubtotal = () => {
    if (isPerito) {
      return getSubTotal();
    }

    return (getSubTotal() - checkoutInfo.presupuesto.total_envio + checkoutInfo.presupuesto.total_descuento).toFixed(2);
  }

  const getIVA = () => {
    const IVAvalue = checkoutInfo.presupuesto?.iva !== 0  ? (getSubTotal() * (1 + checkoutInfo.presupuesto.iva/100)) : 0;
    const IVA = checkoutInfo.presupuesto?.iva !== 0  ? (IVAvalue - getSubTotal()) : IVAvalue;
    return parseFloat(IVA).toFixed(2); 
  }

  const getTotal = (conDescuento) => {
    if(conDescuento) {
      const totalIVA = checkoutInfo.presupuesto.total_iva;
      return parseFloat(totalIVA).toFixed(2);
    } else {
      const totalIVA = checkoutInfo.presupuesto.total_iva + checkoutInfo.presupuesto.total_descuento_iva;
      return parseFloat(totalIVA).toFixed(2);
    }
  }

  return <div className={`total-pedido ${className}`}>
        <h2>{t('carrito.pedido.title')}</h2>
        <p>
            <span>{t('carrito.pedido.subtotal')}</span>
            <span>{getDisplayedSubtotal()}€</span>
        </p>
        {!isPerito &&
          <p>
              <span>{t('carrito.pedido.transporte')}</span>
              {checkoutInfo.presupuesto.total_envio === 0 && checkoutInfo.presupuesto.ecommerce
                ? <span className='total-pedido__no-transporte' onClick={handleSelectDirEnvio}>{t('carrito.pedido.no-transporte')}</span> 
                : <span>{(checkoutInfo.presupuesto.total_envio).toFixed(2)}€</span>}
          </p>
        }
        {checkoutInfo.presupuesto?.vale_descuento &&
          <p>
            <span>
                      {t('carrito.codigo-descuento.descuento')}{' '}
                      <span className="codigo-descuento__aplicado">
                          {checkoutInfo.presupuesto?.vale_descuento?.codigo}
                      </span>
                  </span>
                  <span>
                      -{' '}
                      {checkoutInfo.presupuesto.total_descuento}
                      €
            </span>
          </p>
        }
        <p className='total-pedido__impuestos'>
            <span>{t('carrito.pedido.impuestos')}</span>
            {
              canShowTotals
                ? <span>{getIVA()}€</span>
                : <span className='total-pedido__no-transporte' onClick={handleSelectDirEnvio}>{t('carrito.pedido.no-transporte')}</span>
            }
        </p>

        <CodigoDescuento checkoutInfo={checkoutInfo}/>

        <ProgramaPuntos programaPuntos={checkoutInfo.cliente?.programa_puntos} />

        <h4>
            <span>{t('carrito.pedido.total')}</span>
            <span>{canShowTotals
              ? getTotal(checkoutInfo.presupuesto?.vale_descuento_id) + '€'
              : t('carrito.pedido.no-transporte')}</span>
        </h4>
    </div>
}

TotalPedido.propTypes = {
  className: PropTypes.string
}

export default TotalPedido
